<template>
  <div class="container">
    <!-- 顶部 -->
    <div class="top">
      <van-icon name="cross" size="18" color="var(--text_color)" @click="$router.push({ name: 'Home' })" />
      <div class="right">{{ $t('login').noAccount }} <span @click="$router.push({ name: 'Register' })">{{
        $t('login').Registration }}</span> </div>
    </div>
    <!-- 输入框 -->
    <div class="content">
      <!-- 标题 -->
      <div class="tit">{{ $t('login').title }}</div>
      <!-- 切换 -->
      <div class="tabs">
        <span :class="loginType == 'Email' ? 'active' : ''" @click="loginType = 'Email'" v-if="loginTypeArr.includes('Email')">{{ $t('register').Mailbox
          }}</span>
        <span :class="loginType == 'Phone' ? 'active' : ''" @click="loginType = 'Phone'" v-if="loginTypeArr.includes('Phone')">{{ $t('register').PhoneNumber
          }}</span>
      </div>
      <!-- 电子邮箱-->
      <div class="item" v-if="loginType == 'Email'">
        <van-field v-model="Email" :placeholder="$t('register').placeholder5"></van-field>
      </div>
      <!-- 手机号-->
      <div class="item" v-if="loginType == 'Phone'">
        <van-field v-model="PhoneNumber" type="tel" :placeholder="$t('register').placeholder0">
          <template #left-icon>
            <VueCountryIntl schema="popover" v-model="PhoneNumberCode" :listZIndex="10000" popoverClass="selectCountry2" :searchInputPlaceholder="$t('register').searchCountryMsg" @onChange="selectCountry">
              <i class="select_btn" slot="reference" @click="selectCountry">
                <span> +{{ PhoneNumberCode }}</span>
                <van-icon name="play" size="13" class="ric" color="var(--text_color)" />
                <div class="line"></div>
              </i>
            </VueCountryIntl>
          </template>
        </van-field>
      </div>
      <!-- 密码 -->
      <div class="item">
        <van-field v-model="Password" :type="psdType" :placeholder="$t('register').placeholder1" :right-icon="psdType === 'password' ? 'eye' : 'closed-eye'" @click-right-icon="psdType = psdType === 'password' ? 'text' : 'password'">
        </van-field>
      </div>
      <div class="passInfo">
        <!-- 记住密码 -->
        <van-checkbox icon-size="12" v-model="checkedPass" checked-color="var(--text_color)">{{
          $t('login').rememberpassword }}</van-checkbox>
        <!-- 忘记密码 -->
        <div class="forget" @click="$router.push({ name: 'ForgotPassword' })">{{ $t('login').ForgotPassword }}</div>
      </div>
      <!-- 按钮 -->
      <van-button block @click="handleSub">{{ $t('login').btn }}</van-button>
      <!-- 第三方登录 -->
      <div class="third-login">
        <div class="divider">
          <span class="line"></span>
          <span class="text">{{ $t('login').walletOrDivider }}</span>
          <span class="line"></span>
        </div>
        <div class="wallet-card" @click="handleWalletLogin">
          <div class="wallet-icon" :class="{ loading: walletLoading }">
            <svg viewBox="0 0 31 34" width="44" height="48" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 4.98172L15.3947 0V34.4869C4.39832 29.8882 0 21.075 0 16.0943V4.98172Z" fill="#0500FF" />
              <path d="M30.7892 4.98172L15.3945 0V34.4869C26.3909 29.8882 30.7892 21.075 30.7892 16.0943V4.98172Z" fill="url(#twShieldGrad)" />
              <defs>
                <linearGradient id="twShieldGrad" x1="25.4885" y1="0.42534" x2="15.896" y2="34.5112" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#48FF91" />
                  <stop offset="1" stop-color="#0500FF" />
                </linearGradient>
              </defs>
            </svg>
            <van-loading v-if="walletLoading" size="20" class="wallet-spinner" color="#3375BB" />
          </div>
          <div class="wallet-name">Trust Wallet</div>
        </div>
        <div class="wallet-subtitle">{{ $t('login').walletSubtitle }}</div>
        <div class="wallet-checked" v-if="walletAddress && !walletLoading">
          <van-icon name="checked" color="#07c160" size="12" />
          <span>{{ walletShort }}</span>
        </div>
      </div>
      <!-- 下载app -->
      <div class="downbtn" @click="$router.push({ name: 'Down' })">{{ $t('public').down }} App</div>
    </div>
  </div>
</template>

<script>
import userApi from '@/api/user'
import systemApi from '@/api/system'
import { Token } from '@/utils/mm'
import { EventBus } from '@/utils/event-bus'
import { connectWallet, signMessage } from '@/utils/web3'

export default {
  components: {
  },
  data() {
    return {
      loginTypeArr: [],//支持的登录方式
      loginType: 'Email',
      PhoneNumberCode: '1', //手机区号
      checkedPass: true,//记住密码
      checkedAgree: true,//同意协议
      PhoneNumber: '', //手机号
      Email: '',//邮箱
      Password: '',//密码
      psdType: "password", //输入框类型
      walletAddress: '', // 钱包地址
      walletLoading: false, // 钱包操作加载中
    }
  },
  computed: {
    walletShort() {
      if (!this.walletAddress) return ''
      const addr = this.walletAddress
      return addr.substring(0, 6) + '...' + addr.substring(addr.length - 4)
    }
  },
  mounted() {
    this.getConfig()
    // ✅ iOS 原生回调
    window.cacheCleared = function () {
      console.log("缓存清理成功（iOS 原生）");
    };
  },
  methods: {
    // 选择国家区号
    selectCountry() {
      this.$nextTick(() => {
        const searchInput = document.querySelector(
          '.selectCountry2 .search-input'
        )
        if (searchInput) {
          searchInput.style.width = '90%'
          searchInput.style.height = 'auto'
        }
      })
    },
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      if (res.systemSetting.loginType) {
        this.loginTypeArr = res.systemSetting.loginType
        this.loginType = this.loginTypeArr[0]
      }
      //记住密码
      var loginData = localStorage.getItem('loginData')
      if (loginData) {
        loginData = JSON.parse(loginData)
        this.loginType = loginData.loginType
        this.Password = loginData.passWord
        // 手机号
        if (this.loginType == 'Phone') {
          this.PhoneNumber = loginData.userName
        }
        // 邮箱
        if (this.loginType == 'Email') {
          this.Email = loginData.userName
        }
      }
    },
    // 客服
    async goServe() {
      // const res = await systemApi.getConfig()
      // location.href = res.systemSetting.serviceUrl
      const res = await userApi.getMemberInfo()
      const encodedData = JSON.stringify({ name: res.user.memberId, email: res.user.memberName });
      location.href = 'chatlinkonline.html?metadata=' + encodedData
    },
    // 钱包登录
    async handleWalletLogin() {
      this.walletLoading = true
      try {
        // 1. 连接钱包获取地址
        if (!this.walletAddress) {
          this.walletAddress = await connectWallet()
        }
        // 2. 获取挑战码
        const challengeRes = await userApi.walletChallenge({ walletAddress: this.walletAddress })
        const challenge = challengeRes.challenge
        // 3. 用钱包签名
        const signature = await signMessage(challenge, this.walletAddress)
        // 4. 提交登录
        this.clearCache()
        const loginRes = await userApi.walletLogin({
          loginType: 'Wallet',
          walletAddress: this.walletAddress,
          message: challenge,
          signature: signature
        })
        this.$toast.success(this.$t('login').success)
        Token.set(loginRes.token)
        EventBus.$emit('Login')
        this.$router.push({ name: 'Home' })
      } catch (err) {
        if (err.code === 4001) {
          this.$toast.fail(this.$t('login').walletRejected)
        } else {
          this.$toast.fail(err.message || this.$t('login').walletSignFailed)
        }
      } finally {
        this.walletLoading = false
      }
    },
    // 提交登录
    async handleSub() {
      if (!this.checkForm()) return
      const form = {
        loginType: this.loginType,
        passWord: this.Password,
      }
      // 手机号
      if (this.loginType == 'Phone') {
        form.userName = this.PhoneNumber
      }
      // 邮箱
      if (this.loginType == 'Email') {
        form.userName = this.Email
      }

      // 登录之前清理缓存
      this.clearCache()
      // 登录
      let res = await userApi.login(form)
      this.$toast.success(this.$t('login').success)
      //记住密码 存缓存
      if (this.checkedPass) {
        localStorage.setItem('loginData', JSON.stringify(form))
      } else {
        localStorage.removeItem('loginData')
      }
      Token.set(res.token)
      EventBus.$emit('Login')
      this.$router.push({ name: 'Home' })
    },
    // 表单验证
    checkForm() {
      // 手机号
      if (this.loginType == 'Phone') {
        if (!this.PhoneNumber) {
          this.$toast({
            message: this.$t('login').placeholder,
            position: 'center'
          })
          return false
        }
      }
      // 邮箱
      if (this.loginType == 'Email') {
        if (!this.Email) {
          this.$toast({
            message: this.$t('register').placeholder5,
            position: 'center'
          })
          return false
        }
      }
      // 密码
      if (!this.Password) {
        this.$toast({
          message: this.$t('login').placeholder1,
          position: 'center'
        })
        return false
      }
      return true
    },
    // 清理缓存
    clearCache() {
      var lang = localStorage.getItem('language')
      if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.clearCache
      ) {
        // ✅ iOS WebView 环境
        window.webkit.messageHandlers.clearCache.postMessage(null);
      } else {
        // ✅ 浏览器环境执行本地清理
        localStorage.clear();
        sessionStorage.clear();
        document.cookie.split(";").forEach((c) => {
          const name = c.split("=")[0].trim();
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
        });
        console.log("Web 缓存已清除（浏览器模式）");
      }
      // 设置默认语言
      if (lang) {
        localStorage.setItem('language', lang)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  width: 100%;
  padding: 15px;
  background: var(--background_color);

  .top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .right {
      font-size: 14px;
      color: var(--ntext_color);

      span {
        margin-left: 5px;
        font-weight: bold;
        color: var(--text_color);
      }
    }
  }

  .content {
    .tit {
      margin-top: 30px;
      font-size: 25px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin: 40px 0 20px 0;
      font-weight: bold;
      font-size: 14px;
      color: var(--ntext_color);

      span {
        margin-right: 20px;
      }

      .active {
        color: var(--text_color);
      }
    }

    .item {
      margin-top: 15px;

      .select_btn {
        font-size: 14px;
        color: var(--text_color);
        margin-right: 10px;
        display: flex;
        align-items: center;

        .ric {
          transform: rotate(90deg);
          margin: 0 10px 0 5px;
        }

        .line {
          height: 15px;
          background: var(--ntext_color);
          width: 1px;
        }
      }
    }

    .passInfo {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: 20px;

      .forget {
        font-weight: bold;
        font-size: 12px;
        color: var(--text_color);
      }
    }

    .van-button {
      margin-top: 30px;
      background: var(--text_color);
      height: 40px;
      border-radius: 20px;
      border: 0;
      font-size: 15px;
      color: var(--background_color);
    }

    .downbtn {
      margin-top: 50px;
      text-align: center;
      height: 40px;
      border-radius: 20px;
      font-size: 15px;
      color: var(--text_color);
    }
  }
}

::v-deep .van-field__value {
  overflow: visible;
  display: grid;
}

::v-deep .van-cell {
  background: var(--background_color);
  padding: 0 10px;
  height: 40px;
  margin-bottom: 10px;
  border-radius: 10px;
  font-size: 14px;
  border: 1px solid var(--info_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-field__control::-webkit-input-placeholder {
  color: var(--ntext_color);
  font-size: 14px;
  opacity: 0.9;
}

::v-deep .van-field__left-icon {
  align-items: center;
  display: flex;
}

::v-deep .van-tab {
  font-size: 15px;
  justify-content: left;
}

::v-deep .van-tab--active {
  font-weight: bold;
}

::v-deep .van-checkbox__icon--checked .van-icon {
  color: var(--background_color);
}

::v-deep .van-checkbox__label {
  margin-left: 5px;
  color: var(--text_color);
  font-size: 12px;
  font-weight: bold;
}

.third-login {
  margin-top: 40px;

  .divider {
    display: flex;
    align-items: center;
    margin-bottom: 25px;

    .line {
      flex: 1;
      height: 1px;
      background: var(--info_color);
    }

    .text {
      padding: 0 12px;
      font-size: 12px;
      color: var(--ntext_color);
      white-space: nowrap;
    }
  }

  .wallet-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100px;
    margin: 0 auto;
    padding: 11px 0;
    border: 1px solid var(--info_color);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.07);
    cursor: pointer;
    transition: border-color 0.2s;
    gap: 8px;

    &:active {
      border-color: var(--text_color);
    }

    .wallet-icon {
      position: relative;
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;

      .wallet-spinner {
        position: absolute;
        right: -8px;
        bottom: -8px;
      }
    }

    .wallet-name {
      margin-top: 10px;
      font-size: 13px;
      font-weight: 600;
      color: var(--text_color);
    }
  }

  .wallet-subtitle {
    margin-top: 20px;
    font-size: 12px;
    color: var(--ntext_color);
    text-align: center;
  }

  .wallet-checked {
    margin-top: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    font-size: 12px;
    color: var(--text_color);
    font-family: monospace;
  }
}
</style>
